// Duplicated from https://github.com/spinnaker/clouddriver/blob/master/clouddriver-web/config/clouddriver.yml
// TODO(mneterval): remove after resolution of https://github.com/spinnaker/spinnaker/issues/4859
export const GCE_INSTANCE_TYPE_DISK_DEFAULTS = Object.freeze([
  {
    instanceType: 'n1-standard-1',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-2',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-4',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-8',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-16',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-32',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-64',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-standard-96',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'f1-micro',
    supportsLocalSSD: false,
    disks: [
      {
        type: 'pd-standard',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'g1-small',
    supportsLocalSSD: false,
    disks: [
      {
        type: 'pd-standard',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'e2-small',
    supportsLocalSSD: false,
    disks: [
      {
        type: 'pd-standard',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'e2-micro',
    supportsLocalSSD: false,
    disks: [
      {
        type: 'pd-standard',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'e2-medium',
    supportsLocalSSD: false,
    disks: [
      {
        type: 'pd-standard',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-2',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-4',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-8',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-16',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-32',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-64',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highmem-96',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-2',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-4',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-8',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-16',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-32',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-64',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'n1-highcpu-96',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
  {
    instanceType: 'default',
    disks: [
      {
        type: 'pd-ssd',
        sizeGb: 10,
      },
    ],
  },
]);
